import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FaRegPlayCircle } from 'react-icons/fa';
import { getAction } from '../../redux/action';
import { getComedy } from '../../redux/comedy';
import { getHorror } from '../../redux/horror';
import { getDocumentary } from '../../redux/documentary';
import { getFlixFrenzyOriginals } from '../../redux/flixFrenzyOriginals';
import { getRomance } from '../../redux/romance';
import { getTopRated } from '../../redux/topRated';
import { getTrending } from '../../redux/trending';
import { getNowPlaying } from '../../redux/nowPlaying';
import { getLatest } from '../../redux/latest';
import { getPopular } from '../../redux/popular';
import { getTvAiringToday } from '../../redux/tvAiringToday';
import { getTvLatest } from '../../redux/tvLatest';
import { getTvOnAir } from '../../redux/tvOnAir';
import { getTvPopular } from '../../redux/tvPopular';
import { getTvTopRated } from '../../redux/tvTopRated';
import { getUpComing } from '../../redux/upcoming';
import { getAdventure } from '../../redux/adventure';
import { getAnimation } from '../../redux/animation';
import { getCrime } from '../../redux/crime';
import { getDrama } from '../../redux/drama';
import { getFantasy } from '../../redux/fantasy';
import { getHistory } from '../../redux/history';
import { getKidsAndFamily } from '../../redux/kidsAndFamily';
import { getMusic } from '../../redux/music';
import { getMystery } from '../../redux/mystery';
import { getScienceFiction } from '../../redux/scienceFiction';
import { getThriller } from '../../redux/thriller';
import { getTvMovie } from '../../redux/tvMovie';
import { getWar } from '../../redux/war';
import { getWestern } from '../../redux/western';
import { getTvActionAndAdventure } from '../../redux/tvActionAndAdventure';
import { getTvAnimation } from '../../redux/tvAnimation';
import { getTvComedy } from '../../redux/tvComedy';
import { getTvDocumentary } from '../../redux/tvDocumentary';
import { getTvDrama } from '../../redux/tvDrama';
import { getTvFamily } from '../../redux/tvFamily';
import { getTvKids } from '../../redux/tvKids';
import { getTvMystery } from '../../redux/tvMystery';
import { getTvNews } from '../../redux/tvNews';
import { getTvReality } from '../../redux/tvReality';
import { getTvSciFiAndFantasy } from '../../redux/tvSciFiAndFantasy';
import { getTvSoap } from '../../redux/tvSoap';
import { getTvTalk } from '../../redux/tvTalk';
import { getTvWarAndPolitics } from '../../redux/tvWarAndPolitics';
import { getTvWestern } from '../../redux/tvWestern';
import { getTvCrime } from '../../redux/tvCrime';
import { getTvTrending } from '../../redux/tvTrending';
import './Main.css';
import { getGenres } from '../../redux/genres';
import { getMyList } from '../../redux/myList';
import { getMovie } from '../../redux/playMovie';
import { showMyList } from '../../redux/showMyList';
import loader from '../../assets/loader.gif';

const Home = () => {
  const dispatch = useDispatch();

  const [movie, setMovie] = useState([]);

  const topRated = useSelector((state) => state.topRated);
  const trending = useSelector((state) => state.trending);
  const action = useSelector((state) => state.action);
  const comedy = useSelector((state) => state.comedy);
  const horror = useSelector((state) => state.horror);
  const romance = useSelector((state) => state.romance);
  const animation = useSelector((state) => state.animation);
  const history = useSelector((state) => state.history);
  const tvNews = useSelector((state) => state.tvNews);
  const documentary = useSelector((state) => state.documentary);

  useEffect(() => {
    dispatch(getFlixFrenzyOriginals({ type: 'GET_FlixFrenzyORIGINALS' }));
    dispatch(getAction({ type: 'GET_ACTION' }));
    dispatch(getComedy({ type: 'GET_COMEDY' }));
    dispatch(getHorror({ type: 'GET_HORROR' }));
    dispatch(getDocumentary({ type: 'GET_DOCUMENTARY' }));
    dispatch(getNowPlaying({ type: 'GET_NOWPLAYING' }));
    dispatch(getRomance({ type: 'GET_ROMANCE' }));
    dispatch(getTopRated({ type: 'GET_TOPRATED' }));
    dispatch(getTrending({ type: 'GET_TRENDING' }));
    dispatch(getLatest({ type: 'GET_LATEST' }));
    dispatch(getPopular({ type: 'GET_POPULAR' }));
    dispatch(getTvAiringToday({ tyep: 'GET_TVAIRINGTODAY' }));
    dispatch(getTvLatest({ type: 'GET_TVLATEST' }));
    dispatch(getTvOnAir({ type: 'GET_TVONAIR' }));
    dispatch(getTvPopular({ type: 'GET_TVPOPULAR' }));
    dispatch(getTvTopRated({ type: 'GET_TVTOPRATED' }));
    dispatch(getUpComing({ type: 'GET_UPCOMING' }));
    dispatch(getAdventure({ type: 'GET_ADVENTURE' }));
    dispatch(getAnimation({ type: 'GET_ANIMATION' }));
    dispatch(getCrime({ type: 'GET_CRIME' }));
    dispatch(getDrama({ type: 'GET_DRAMA' }));
    dispatch(getFantasy({ type: 'GET_FANTASY' }));
    dispatch(getHistory({ type: 'GET_HISTORY' }));
    dispatch(getKidsAndFamily({ type: 'GET_KIDSANDFAMILY' }));
    dispatch(getMusic({ type: 'GET_MUSIC' }));
    dispatch(getMystery({ type: 'GET_MYSTERY' }));
    dispatch(getScienceFiction({ type: 'GET_SCIENCEFICTION' }));
    dispatch(getThriller({ type: 'GET_THRILLER' }));
    dispatch(getTvMovie({ type: 'GET_TVMOVIE' }));
    dispatch(getWar({ type: 'GET_WAR' }));
    dispatch(getWestern({ type: 'GET_WESTERN' }));
    dispatch(getTvActionAndAdventure({ type: 'GET_TVACTIONANDADVENTURE' }));
    dispatch(getTvAnimation({ type: 'GET_TVANIMATION' }));
    dispatch(getTvComedy({ type: 'GET_TVCOMEDY' }));
    dispatch(getCrime({ type: 'GET_CRIME' }));
    dispatch(getTvDocumentary({ type: 'GET_TVDOCUMENTARY' }));
    dispatch(getTvDrama({ type: 'GET_TVDRAMA' }));
    dispatch(getTvFamily({ type: 'GET_TVFAMILY' }));
    dispatch(getTvKids({ type: 'GET_TVKIDS' }));
    dispatch(getTvMystery({ type: 'GET_TVMYSTERY' }));
    dispatch(getTvNews({ type: 'GET_TVNEWS' }));
    dispatch(getTvReality({ type: 'GET_TVREALITY' }));
    dispatch(getTvSciFiAndFantasy({ type: 'GET_TVSCIFIANDFANTASY' }));
    dispatch(getTvSoap({ type: 'GET_TVSOAP' }));
    dispatch(getTvTalk({ type: 'GET_TVTALK' }));
    dispatch(getTvWarAndPolitics({ type: 'GET_TVWARANDPOLITICS' }));
    dispatch(getTvWestern({ type: 'GET_TVWESTERN' }));
    dispatch(getTvCrime({ type: 'GET_TVCRIME' }));
    dispatch(getTvTrending({ type: 'GET_TVTRENDING' }));
    dispatch(getGenres({ type: 'GET_GENRES' }));
    dispatch(getMyList({ type: 'GET_MYLIST' }));
  }, [dispatch]);

  let allMovies;

  if (Array.isArray(trending.results)) {
    allMovies = topRated.results.concat(trending.results,
      action.results, comedy.results, horror.results, romance.results,
      animation.results, history.results, tvNews.results, documentary.results);
  } else {
    allMovies = [{
      adult: false,
      backdrop_path: '/h8gHn0OzBoaefsYseUByqsmEDMY.jpg',
      genre_ids: [28, 53, 80],
      id: 603692,
      original_language: 'en',
      original_title: 'John Wick: Chapter 4',
      overview: 'With the price on his head ever increasing, John Wick uncovers a path to defeating The High Table. But before he can earn his freedom, Wick must face off against a new enemy with powerful alliances across the globe and forces that turn old friends into foes.',
      popularity: 3911.607,
      poster_path: '/vZloFAK7NmvMGKE7VkF5UHaz0I.jpg',
      release_date: '2023-03-22',
      title: 'John Wick: Chapter 4',
      video: false,
      vote_average: 7.9,
      vote_count: 2828,
    }];
  }
  const moviesWithUrls = allMovies.filter((mov) => mov.backdrop_path !== null);

  useEffect(() => {
    setMovie(
      moviesWithUrls[
        Math.floor(Math.random() * moviesWithUrls.length - 1)
      ],
    );
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const truncate = (str, n) => (
    str?.length > n ? `${str.substr(0, n - 1)}...` : str);

  const handleClick = (movie) => {
    const play = true;
    const playMovieProps = { movie, play };
    dispatch(getMovie(playMovieProps));
    // if (movie) {
    //   dispatch(addMyList(movie));
    // }
  };

  const showLists = () => {
    const showMyListState = { showList: true };
    dispatch(showMyList(showMyListState));
  };

  return (
    <>
      {movie ? (
        <>
          <div
            className="home-movie"
            style={{
              backgroundSize: 'cover',
              backgroundImage: `url("https://image.tmdb.org/t/p/original/${movie?.backdrop_path}")`,
              backgroundPosition: 'center center',
            }}
          >
            <div className="home-movie-contents">
              <h1 className="home-movie-title">
                {movie?.title || movie?.name || movie?.original_name}
              </h1>
              <div className="home-movie-buttons">
                <button className="home-movie-button play-btn" type="button" onClick={() => handleClick(movie)}>
                  <span>Play</span>
                  <FaRegPlayCircle />
                </button>
                <button className="home-movie-button" type="button" onClick={() => showLists()}>My List</button>
              </div>
              <p className="home-movie-description">
                {truncate(movie?.overview, 200)}
              </p>
            </div>
            <div className="home-movie--fadeBottom" />
          </div>
          <div />
        </>
      ) : (
        <div className="pop-movie-loader-section">
          <img src={loader} className="pop-movie-loader" alt="FlixFrenzy" />
        </div>
      )}
    </>

  );
};

export default Home;
